// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hex-input-wrapper{position:relative;border-radius:3px;border:1px solid #f0f0f0;overflow:hidden}.hex-input-wrapper label{margin:unset;position:absolute;left:0;top:0;bottom:0;width:25px;background-color:#f0f0f0;display:grid;place-content:center;font-size:1.4rem;font-weight:300;color:#9fa6a8 !important}.hex-input-wrapper input.hex-input{position:absolute;left:25px;top:0;right:0;bottom:0;border-radius:unset;border:none;padding-inline:6px;text-transform:uppercase;color:#666}\n", ""]);
// Exports
module.exports = exports;
